export default __webpack_public_path__ + "static/media/Logo.ba43354c.svg";